export const startTimecardMission = (id) => ({
  type: "START_TIMECARD_MISSION",
  id
});



// WEBPACK FOOTER //
// ./src/store/actions/help/timecards.js